import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../services';
import { routes } from '../../../../consts';
import { ActivatedRoute, Route } from '@angular/router';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auth-page',
  templateUrl: './auth-page.component.html',
  styleUrls: ['./auth-page.component.scss']
})
export class AuthPageComponent {
  public todayDate: Date = new Date();
  public routers: typeof routes = routes;
  public isLoading = false;

  userData: any;

  constructor(
    private service: AuthService,
    private route: ActivatedRoute, 
    private router: Router
  ) { }

  
  ngOnInit(): void {
  
    
  //  Step 1: Handle tokens in the URL fragment FIRST
  this.route.fragment.subscribe(fragment => {
    if (fragment) {
      const params = new URLSearchParams(fragment);

      const idToken = params.get('id_token');
      const accessToken = params.get('access_token');
      const refreshToken = params.get('refresh_token');
      const expiresIn = params.get('expires_in');

      if (idToken && accessToken) {
        localStorage.setItem('token_id', idToken);
        localStorage.setItem('refresh_token', refreshToken || '');
        localStorage.setItem('access_token', accessToken);
        localStorage.setItem('expires_in', expiresIn || '');
      }
    }
  });

  //  Step 2: Load route resolver data AFTER token is stored
  this.route.data.subscribe((data) => {
    this.userData = data['userData'];
    console.log(this.userData);

    this.isLoading = true;
    const user = this.userData?.data?.user;
    if (user) {
      localStorage.setItem('role', user.user_role || '');
      localStorage.setItem('customer_id', user.customer_id || '');
      localStorage.setItem('username', user.username || '');
      localStorage.setItem('customer_logo', user.customer_logo || '');
      localStorage.setItem('user_id', user.user_id || '');
      localStorage.setItem('institute_id', user.institute_id || '');
      localStorage.setItem('isSwitched', 'false');
      localStorage.removeItem('isSwitched');
    }


    const connectionPool = this.userData?.data?.connection_pool;
    if (connectionPool) {
      localStorage.setItem('connection_pool', connectionPool);
    }
    if(user.user_role=='C'){
      const to='customer';
      this.router.navigate([to]);
    }else{
      const to='dashboard';
      this.router.navigate([to]);
    }
  });

}
  
  private goToDashboard() {
    // This will trigger AuthGuard + Resolver
    this.router.navigate(['/dashboard']);
  }

  public gotoLoginPage(){
    window.location.href = environment.loginUrl; 
  }

  
}
